// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__22GXf","title":"InfoRow_title__2QXKH"};